// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gA82OPZztf8xcA {
  margin: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-100, 8px);
  padding: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-background-information, #e9f2ff);
  color: var(--ds-text-subtle, #44546f);
}
.aDLz0tx5wtbPs0 {
  color: var(--ds-text-disabled, #091e424f);
  pointer-events: none;
}
.UbRykiF1H1R39Y {
  color: var(--ds-text-danger, #ae2a19);
}
`, ""]);
// Exports
export var boardVisibilityDescription = `gA82OPZztf8xcA`;
export var boardVisibilityOptionDisabled = `aDLz0tx5wtbPs0`;
export var boardVisibilityDisabledMessaging = `UbRykiF1H1R39Y`;
export default ___CSS_LOADER_EXPORT___;
